import { Inject, Injectable, Type } from '@angular/core';
import { Claims } from '@core/authentication/claims';
import { ClaimsService } from '@core/authentication/claims.service';

type ComponentRegistry = {
  [Claims.Country.Australia]: Type<any>;
  [Claims.Country.NewZealand]: Type<any>;
};

@Injectable({
  providedIn: 'root'
})
export class CountryComponentRegistryService {
  constructor(protected readonly claimsService: ClaimsService) {}

  getCountry(): Claims.Country {
    return this.claimsService.country;
  }

  get(config: ComponentRegistry): Type<any> {
    return config[this.getCountry()];
  }
}
